export enum ApplicationIdentifierEnum {
	Community = 103,
}
